<template lang="pug">
.gu24-location(:class="theme")
  .gu24-location__anchor(@click="click", title="Выбрать город",
    :class="{ 'gu24-location__anchor_active': active }")
    span.gu24-location__anchor__icon(v-if="theme === 'white'")
    span.gu24-location__anchor__value(:title="title.length ? title : name")
      slot {{ name }}
    span.gu24-location__anchor__icon(v-if="theme === 'dark'")
</template>

<script>
export default {
  name: 'LocationAnchor',
  props: {
    name: {
      type: String,
      required: false,
      default: '',
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
    active: {
      type: Boolean,
      required: false,
      default: false,
    },
    theme: {
      type: String,
      default: 'dark',
      required: false,
    },
  },
  methods: {
    click(e) {
      this.$emit('click', e);
    },
  },
};
</script>

<style lang="scss">
.white.gu24-location {
  user-select: none;
}

.white .gu24-location {
  @media screen and (min-width: 960px) {
    width: 103.5px;
  }
  @media screen and (max-width: 960px) {
    width: 8.25rem;
  }
  &__anchor {
    font-family: 'Rubik', sans-serif;
    font-size: 14 / 16 + rem;
    margin: 0 30 / 16 + rem;
    @media screen and (max-width: 960px) {
      font-size: 1.2rem;
      margin: 0 0 0 1rem;
      width: 8.25rem;
      display: flex;
    }
    @media screen and (min-width: 960px) {
      width: 103.5px;
    }
    cursor: pointer;
    color: rgb(21, 21, 21);
    transition: all .25s ease;
    position: relative;
    // &:hover {}
    &__value {
      display: inline-block;
      text-overflow: ellipsis;
      white-space: nowrap;
      // overflow: hidden;
    }

    &__icon {
      display: inline-block;
      width: 11 / 16 + rem;
      min-height: .725rem;
      background-image: url('./images/location.svg');
      background-size: contain;
      background-repeat: no-repeat;
      transition: all .25s ease;
      margin-right: 7px;
    }
  }
}

.white .gu24-location__anchor_active .gu24-location__anchor__value {
  text-decoration: underline;
}

.dark.gu24-location {
  user-select: none;
  float: left;
}
.dark .gu24-location {
  &__anchor {
    font-family: 'Montserrat', sans-serif;
    letter-spacing: 0.075em;
    max-width: 210 / 16 + rem;
    font-size: 10 / 16 + rem;
    font-weight: 600;
    cursor: pointer;
    padding: 26 / 16 + rem 42 / 16 + rem 24 / 16 + rem 30 / 16 + rem; // 42 30 + 6 + 6 in icon
    color: rgb(255, 255, 255);
    text-transform: uppercase;
    transition: all .25s ease;
    position: relative;
    &:hover {
      background-color: rgb(36, 36, 36) - 7;
    }
    &__value {
      width: 100%;
      display: block;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }

    &__icon {
      display: block;
      width: 6 / 16 + rem;
      min-height: 5 / 16 + rem;
      background-image: url('./images/arrow-down.svg');
      background-size: contain;
      background-repeat: no-repeat;
      position: absolute;
      right: 30 / 16 + rem;
      top: 29 / 16 + rem;
      transition: all .25s ease;
    }
    &_active {
      background-color: rgb(36, 36, 36) - 7;
    }
    &_active &__icon {
      transform: rotate(180deg);
    }
  }
}
</style>
